import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface MultiSelectParams {
  selectedNotifications: string[];
  selectAllNotificationsForMultiSelectFlag: boolean;
  setDefaultPage?: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class NotificationSharedService {
  private setSelectAllFlagSubject = new Subject<any>();
  private setDefaultValuesMultiSelectSubject = new Subject<any>();
  private setSelectedPanelsSubject = new Subject<any>();

  selectAllFlagTriggerAction$ = this.setSelectAllFlagSubject.asObservable();
  setDefaultValuesMultiSelectSubjectTriggerAction$ = this.setDefaultValuesMultiSelectSubject.asObservable();
  setSelectedPanelsSubjectTriggerAction$ = this.setSelectedPanelsSubject.asObservable();

  setSelectAllFlag(selectAllFlag: boolean) {
    this.setSelectAllFlagSubject.next(selectAllFlag);
  }

  setDefaultValuesMultiSelect({selectedNotifications, selectAllNotificationsForMultiSelectFlag, setDefaultPage = false}: MultiSelectParams) {
    this.setDefaultValuesMultiSelectSubject.next({selectedNotifications, selectAllNotificationsForMultiSelectFlag, setDefaultPage});
  }

  updatedSelectedPanelsOnHome(selectedPanels: any) {
    this.setSelectedPanelsSubject.next(selectedPanels);
  }
}
